import React, { Component } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";
import { setsubcategory } from "../../actions/setsubcategoryaction";
import AlertDialogBox from "../DailogBoxes/alertdailogbox";
import Service from "../../Service/firebase";
import ErorrDialogBox from "../DailogBoxes/errordaologbox";
import EditPersonDetailsForm from "../Doctors/editpersondetailsform";
import EditSubCategoryForm from "../SubCategory/editsubcategoryform";
class EditPersonDetails extends Component {
  constructor(props) {
    super(props);
    console.log("hey yd " +this.props.subcategory.name);
    this.state = {
      date: this.props.subcategory.birthdate,
      startDate: new Date(this.props.subcategory.birthdate),
      image: "",
      profileHtmlelEment: (
        <i className="fa fa-user fa-8x" aria-hidden="true"></i>
      ),
      isLoading: false,
      openAlertDailog: false,
      openErrorDailog: false,

      subcategory: {
        
       
        name: this.props.subcategory.name,
        imgaeurl: this.props.subcategory.imgaeurl,
       
        collectionName: this.props.subcategory.collectionName,
      },
    };
  }

  handleSubmit = () => {
    this.setState({
      isLoading: true,
    });

    this.handleImageForUpload();
  };
  handleImageForUpload = () => {
    const image = this.state.image;

    if (this.state.image !== "") {
      this.onUploadImage(image);
    } else {
      this.onUpdate();
    }
  };
  onUploadImage = async (image) => {
    const url = await Service.uploadImage(image);
    if (url !== "") {
      this.setState({
        subcategory: {
          ...this.state.subcategory,
          imgaeurl: url,
        },
      });

      this.onUpdate();
    }
  };
  async onUpdate() {
    const sendData = {
      ...this.state.subcategory,
      searchbyname: (
        this.state.subcategory.name
      ).toLowerCase(),
    };
    const res = await Service.updateData(
      sendData,
      this.props.subcategory.collectionName,
      this.props.subcategory.personId
    );
    if (res === "success") {
      this.setState({
        isLoading: false,
        openAlertDailog: true,
        alertDailogBoxTitle: "Update",
        alertDailogBoxDes: "successfully updated",
      });

      let subcategory = this.state.subcategory;
      subcategory = {
        ...this.state.subcategory,
        collectionName: this.props.subcategory.collectionName,
        personId: this.props.subcategory.personId,
      };

      this.props.setOsubcategory(subcategory);
    } else {
      this.setState({
        isLoading: false,
      });
      this.handleErrorDailog();
    }
  }
  handleErrorDailog = () => {
    this.setState({
      openErrorDailog: true,
    });
  };
  closeErrorDailog = () => {
    this.setState({
      openErrorDailog: false,
    });
  };
  handleChange = (date) => {
    if (date !== null) {
      const birthDate = new Date(date);

      this.setState({
        subcategory: {
          ...this.state.subcategory,
          birthdate: `${
            birthDate.getMonth() + 1
          }/${birthDate.getDate()}/${birthDate.getFullYear()}`,
        },
        date: date,
        startDate: date,
      });
    } else {
      this.setState({
        subcategory: {
          ...this.state.subcategory,
          birthdate: date,
        },
        date: date,
        startDate: date,
      });
    }
  };
  onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      this.setState({
        image: event.target.files[0],
      });
      let reader = new FileReader();
      reader.onload = (e) => {
        this.setState({
          subcategory: {
            ...this.state.subcategory,
            imgaeurl: e.target.result,
          },
        });
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };
  onImageRemove = () => {
    this.setState({
      subcategory: {
        ...this.state.subcategory,
        imgaeurl: "",
      },
      image: "",
    });
  };

  onEdit = (e) => {
    let subcategory = this.state.subcategory;

    this.setState({
      subcategory: {
        ...this.state.subcategory,
        [e.target.name]: e.target.value,
      },
    });
    console.log(subcategory);
  };
  handleSetOpenDailog = () => {
    this.setState({
      setAlertOpenDailog: false,
      openAlertDailog: false,
    });
  };

  render() {
    if (this.state.subcategory.imgaeurl === "") {
      this.state.profileHtmlelEment = (
        <div className="EditPersonDetailspage">
          <i className="fa fa-user fa-8x" aria-hidden="true"></i>
        </div>
      );
    } else {
      this.state.profileHtmlelEment = (
        <div className="EditPersonDetailspage">
          <img
            className="netimage"
            srcSet={this.state.subcategory.imgaeurl}
            alt=""
          />
        </div>
      );
    }

    return this.state.isLoading ? (
      <div className="EditPersonDetailspage">
        <i
          className="fas fa-spinner fa-pulse fa-4x"
          style={{ position: "fixed", top: "50%", left: "50%" }}
        ></i>
      </div>
    ) : (
      <div className="EditPersonDetailspage">
        <AlertDialogBox
          openDailog={this.state.openAlertDailog}
          setOpenDailog={this.state.setOpenAlertDailog}
          onSetOpenDailog={this.handleSetOpenDailog}
          title="Update"
          des="successfully updated"
        ></AlertDialogBox>
        <ErorrDialogBox
          openDailog={this.state.openErrorDailog}
          onSetOpenDailog={this.closeErrorDailog}
          title="Error"
          des="Someting went wrong. Try again"
        ></ErorrDialogBox>
        <EditSubCategoryForm
          handleSubmit={this.handleSubmit}
          onEdit={this.onEdit}
          date={this.state.date}
          handleChange={this.handleChange}
          subcategory={this.state.subcategory}
          profileHtmlelEment={this.state.profileHtmlelEment}
          onImageRemove={this.onImageRemove}
          onImageChange={this.onImageChange}
          handleImageForUpload={this.handleImageForUpload}
        ></EditSubCategoryForm>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    subcategory: state.subcategory,
  };
};
const mapDisptachToProps = (dispatch) => {
  return {
    setOsubcategory: (p) => {
      dispatch(setsubcategory(p));
    },
  };
};
export default connect(mapStateToProps, mapDisptachToProps)(EditPersonDetails);
